import { render, staticRenderFns } from "./EditCorporateVendorModal.vue?vue&type=template&id=54eafa20"
import script from "./EditCorporateVendorModal.vue?vue&type=script&lang=js"
export * from "./EditCorporateVendorModal.vue?vue&type=script&lang=js"
import style0 from "./EditCorporateVendorModal.vue?vue&type=style&index=0&id=54eafa20&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports